"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateAuthContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const auth_request_1 = require("./auth.request");
const auth_response_1 = require("./auth.response");
const c = (0, core_1.initContract)();
exports.CandidateAuthContract = c.router({
    forgotPassword: {
        summary: 'Candidate forgot password',
        method: 'POST',
        path: '/forgot-password',
        body: auth_request_1.CandidateForgotPasswordRequestSchema,
        responses: { 200: schemas_1.BaseResponseSchema },
    },
    logout: {
        description: 'Logs out the user and clears the session',
        method: 'DELETE',
        path: '/logout',
        responses: {
            200: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    me: {
        method: 'GET',
        path: '/me',
        headers: auth_request_1.CandidateAuthorizationHeaderSchema,
        responses: {
            200: auth_response_1.CandidateGetSessionResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    register: {
        summary: 'Candidate registration',
        method: 'POST',
        path: '/register',
        body: auth_request_1.CandidateRegisterRequestSchema,
        responses: {
            201: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            409: schemas_1.BaseErrorResponseSchema,
            422: schemas_1.BaseErrorResponseSchema,
        },
        strictStatusCodes: true,
    },
}, { pathPrefix: '/auth' });
